const integrationLogType = {
  ZPOD_POSTING: 'ZPOD_POSTING',
  MODIFIED_PICKLIST_POSTING: 'MODIFIED_PICKLIST_POSTING',
  FREIGHT_PROVISION_POSTING: 'FREIGHT_PROVISION_POSTING',
  FREIGHT_INVOICE_POSTING: 'FREIGHT_INVOICE_POSTING',
  MATERIAL_INVOICE: 'MATERIAL_INVOICE',
  GRN: 'GRN',
  BULK_INDENT: 'BULK_INDENT',
  DIRECT_DISPATCH: 'DIRECT_DISPATCH',
  SHIPMENT_STATUS: 'TRACKING_STATUS',
  DISCARD_OPTIMA: 'DISCARDED_DELIVERY'
};

const courierLogType = {
  LR_BOOKING: 'LR_BOOKING',
  LR_CANCELLATION: 'LR_CANCELLATION',
  LR_UPDATE: 'LR_UPDATE',
  LR_TRACKING: 'LR_TRACKING',
  LR_POD_FETCH: 'LR_POD_FETCH'
};

const INTEGRATION_TYPE = {
  ALL_SUCCESSFUL_OUTBOUND: '1',
  MODIFIED_PICKLIST_POSTING: '2',
  FREIGHT_PROVISION_POSTING: '3',
  ZPOD_POSTING: '4',
  FREIGHT_INVOICE_POSTING: '5',
  MATERIAL_INVOICE: '6',
  GRN: '7',
  BULK_INDENT: '8',
  DIRECT_DISPATCH: '9',
  TRACKING_STATUS: '10',
  DISCARDED_DELIVERY: '11'
};

const COURIER_TYPE = {
  ALL_SUCCESSFULL_COURIER: '1',
  LR_BOOKING: '2',
  LR_CANCELLATION: '3',
  LR_UPDATE: '4',
  LR_TRACKING: '5',
  LR_POD_FETCH: '6',
};

const entityType = {
  INDENT: 'INDENT',
  INVOICE: 'INVOICE',
  INBOUND_TRANSACTION: 'INBOUND_TRANSACTION',
  LR_NUMBER: 'LR_NUMBER',
  OPTIMA_TRANSACTION: 'OPTIMA_TRANSACTION',
};

const interfaceEventType = {
  INTEGRATION: '1',
  COURIER: '2'
}
const transactionTypes = {
  INBOUND: 'inbound',
  OUTBOUND: 'outbound',
  COURIER: 'courier'
};

const courierLogsFallBackValues = {
  bookingId: 'N/A',
  statusCode: 200,
  errorMessage: 'Transaction Failed',
  successMessage: 'Success',
};

module.exports = {
  integrationLogType,
  INTEGRATION_TYPE,
  entityType,
  transactionTypes,
  COURIER_TYPE,
  courierLogType,
  interfaceEventType,
  courierLogsFallBackValues,
};
